import useSharedData from "./useSharedData";

const usePDFDownload = () => {
  const { user } = useSharedData();
  const streamPDF = user?.isStreamingPDF ? true : false;

  const blobToFile = data => {
    const url = window.URL.createObjectURL(
      new Blob([data], { type: "application/pdf" })
    );

    if (streamPDF === true) {
      window.open(url, "_blank");
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "factor");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    URL.revokeObjectURL(url);
  };

  return { blobToFile };
};

export default usePDFDownload;
